import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  line: [],
  revenueLine: [],
  pie: [],
};

export const fetchLineGraph = createAsyncThunk(
  "fetchLineGraph/analytics",
  async ({ data, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.post("line", data);
      return {
        data: response.data.data,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchRevenueGraph = createAsyncThunk(
  "fetchRevenueGraph/analytics",
  async ({ data, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.post("revenue-line", data);
      return {
        data: response.data.data,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchPieGraph = createAsyncThunk(
  "fetchPieGraph/analytics",
  async ({ data, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.post("pie", data);
      return {
        data: response.data.data,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  extraReducers: (builder) => {
    // ==========================

    // TODO: fetch product
    builder.addCase(fetchLineGraph.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchLineGraph.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.line = action.payload;
    });

    builder.addCase(fetchLineGraph.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch product
    builder.addCase(fetchPieGraph.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchPieGraph.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.pie = action.payload;
    });

    builder.addCase(fetchPieGraph.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

      // ==========================
      // TODO: fetch revenue graph
      builder.addCase(fetchRevenueGraph.pending, (state, _) => {
        state.fetchLoading = true;
      });

      builder.addCase(fetchRevenueGraph.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.revenueLine = action.payload;
      });

      builder.addCase(fetchRevenueGraph.rejected, (state, action) => {
        state.fetchLoading = false;
        action.payload.enqueueSnackbar(action.payload.error.message, {
          variant: "error",
        });
      });
      // ==========================
  },
});

export default analyticsSlice.reducer;
